import apiClient from './client'

// ============================================================================
// TYPES
// ============================================================================

export interface ImportPersonasResult {
  created: number
  updated: number
  deactivated: number
  skipped: number
  errors: { row: number; error: string }[]
  centros_created: number
  centros_updated: number
}

export interface PreviewFieldChange {
  old: string
  new: string
  label: string
}

export interface PreviewCreateItem {
  row: number
  nombre: string
  apellidos: string
  full_name: string
  dni: string
  centro: string
  puesto: string
}

export interface PreviewUpdateItem {
  row: number
  persona_id: number
  full_name: string
  dni: string
  centro: string
  changes: Record<string, PreviewFieldChange>
}

export interface PreviewDeactivateItem {
  persona_id: number
  full_name: string
  dni: string
  centro: string
}

export interface ImportPreviewResult {
  to_create: PreviewCreateItem[]
  to_update: PreviewUpdateItem[]
  to_deactivate: PreviewDeactivateItem[]
  skipped: number
  errors: { row: number; error: string }[]
}

// ============================================================================
// API FUNCTIONS
// ============================================================================

export const previewImportPersonas = async (file: File): Promise<ImportPreviewResult> => {
  const formData = new FormData()
  formData.append('file', file)

  const response = await apiClient.post<ImportPreviewResult>('/import/personas/preview/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })

  return response.data
}

export const importPersonas = async (
  file: File,
  options?: { deactivateMissing?: boolean; excludedRows?: number[]; excludedDeactivations?: number[] }
): Promise<ImportPersonasResult> => {
  const formData = new FormData()
  formData.append('file', file)
  if (options?.deactivateMissing) {
    formData.append('deactivate_missing', 'true')
  }
  if (options?.excludedRows?.length) {
    formData.append('excluded_rows', JSON.stringify(options.excludedRows))
  }
  if (options?.excludedDeactivations?.length) {
    formData.append('excluded_deactivations', JSON.stringify(options.excludedDeactivations))
  }

  const response = await apiClient.post<ImportPersonasResult>('/import/personas/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })

  return response.data
}
